module.exports = __webpack_public_path__ + "static/media/wordmark.c7fda10e.svg";